import { render, staticRenderFns } from "./devicem.vue?vue&type=template&id=2c4cfe52&"
import script from "./devicem.vue?vue&type=script&lang=js&"
export * from "./devicem.vue?vue&type=script&lang=js&"
import style0 from "./devicem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports